// extracted by mini-css-extract-plugin
export default {"wrapper":"SkeletonMiner_wrapper__eI2im","item":"SkeletonMiner_item__DGXgy"};